(function (M) {
  if (!M) return;
  var d = document;
  if (!d.querySelector('.fp')) return;
  var visible = function (el) { return el && el.offsetParent !== null; };
  var heroTxt = d.querySelector('.fp-hero .g > div:first-child');
  if (heroTxt) M.tag(M.all(':scope > *', heroTxt), 'up', { d: 0.1, step: 0.12 });
  var heroP = d.querySelector('.fp-hero p');
  if (heroP) M.count(heroP, '2,500');
  var heroPh = d.querySelector('.fp-hero .ph');
  if (heroPh) {
    M.tag(heroPh, 'fade');
    heroPh.classList.add('mo-waved');
    var wave = function (cls, y) {
      return '<svg class="' + cls + '" viewBox="0 0 1600 80" preserveAspectRatio="none"><path d="M0 ' + y +
        ' Q100 ' + (y - 26) + ' 200 ' + y + ' T400 ' + y + ' T600 ' + y + ' T800 ' + y + ' T1000 ' + y +
        ' T1200 ' + y + ' T1400 ' + y + ' T1600 ' + y + ' V80 H0 Z"/></svg>';
    };
    M.add(heroPh, '<div class="mo-wave mo-deco" aria-hidden="true">' + wave('w1', 44) + wave('w2', 54) + '</div>');
  }
  var aboutPh = d.querySelector('.fp-about .ph');
  if (aboutPh) {
    M.tag(aboutPh, 'zoom');
    aboutPh.setAttribute('data-mo-play', '');
    aboutPh.classList.add('mo-kb');
  }
  var aboutTxt = d.querySelector('.fp-about .g > div:last-child');
  if (aboutTxt) M.tag(M.all(':scope > *', aboutTxt), 'up', { step: 0.12 });
  M.tag('.fp-tech .fp-kick, .fp-tech h2, .fp-tech .lead', 'up', { step: 0.1 });
  M.tag('.fp-tech .im', 'zoom');
  M.tag('.fp-tech h3', 'up');
  var steps = d.querySelector('.fp-steps');
  if (steps) {
    steps.setAttribute('data-mo-play', '');
    steps.classList.add('mo-flow');
    M.add(steps, '<i class="mo-steps-line mo-deco" aria-hidden="true"></i>');
    M.tag(M.all(':scope > div', steps), 'up', { d: 0.1, step: 0.45 });
  }
  M.tag('.fp-form h2', 'up');
  M.all('.fp-ing .r').forEach(function (r, i) {
    M.tag(r, 'left', { d: 0.1 + i * 0.16 });
    var mg = r.querySelector('.mg');
    var n = mg && mg.textContent.match(/\d[\d,]*/);
    if (n) M.count(mg, n[0]);
  });
  M.tag('.fp-form .facts', 'fade', { d: 0.2 });
  var planTxt = d.querySelector('.fp-plan .g > div:first-child');
  if (planTxt) M.tag(M.all(':scope > *', planTxt).filter(visible), 'up', { step: 0.1 });
  M.tag(M.all('.fp-plan .fp-opt').filter(visible), 'up', { d: 0.15, step: 0.1 });
  M.tag('.fp-plan .go', 'up', { d: 0.3 });
})(window.FJKMotion);
